import { useTranslation } from 'react-i18next';
import { Transaction } from '../../../services/types';
import { GateScreen, GateStatus } from '../components';

interface Props {
  transaction: Transaction;
  uuid: string;
  onRedirect: () => void;
}

const GateSuccessPage = ({ transaction, uuid, onRedirect }: Props) => {
  const { t } = useTranslation();
  return (
    <GateScreen
      uuid={uuid}
      actions={[{ label: t('common.returnToMerchant'), onClick: onRedirect, variant: 'green', dataSentryElement: 'onepage-success-return' }]}
    >
      <GateStatus tone="success" title={t('success.title')} text={t('success.description')} />
    </GateScreen>
  );
};

export default GateSuccessPage;
